import { div, inputSubmit, form, inputButton } from "./dom";
import { Loading } from "./loading";

export enum OverlayStyle {
  Classic,
  Viz,
}

export class Overlay {
  static overlays: Overlay[] = [];

  panel: HTMLElement;
  cover: HTMLElement;
  cancel_cb?: Function;
  dismissible: boolean = true;

  constructor(style: OverlayStyle, title: string, elements: HTMLElement[], button_label: string, submit_cb: Function, cancel_cb?: Function, open_cb?: Function, delete_cb?: Function) {
    this.panel = div("page-overlay", "overlay-panel");
    if (style === OverlayStyle.Viz) {
      this.panel.classList.add("viz");
    }
    this.cover = div("overlay-cover", "page-overlay-cover");
    this.cancel_cb = cancel_cb;
    let body: HTMLElement = div();
    if (style === OverlayStyle.Classic) {
      body = form();
    }

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 20 20");
    const p1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p1.setAttribute("d", "M2 2L18 18");
    svg.appendChild(p1);
    const p2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p2.setAttribute("d", "M18 2L2 18");
    svg.appendChild(p2);
    svg.onclick = function (e) {
      self.close();
      e.stopPropagation();
    };

    const header = div("overlay-header");
    if (style === OverlayStyle.Classic) {
      header.classList.add("key_color");
    }
    header.innerHTML = title;
    header.appendChild(svg);
    body.appendChild(header);

    for (let elem of elements) {
      body.appendChild(elem);
    }

    const footer = div("overlay-footer");
    if (delete_cb) {
      const delete_submit = inputButton("white_button", "delete");
      delete_submit.value = "Delete";
      delete_submit.onclick = function (e) {
        e.preventDefault();
        delete_cb();
      }
      footer.appendChild(delete_submit);
    }
    const self = this;
    const submit = inputSubmit("white_button", "key_button", "key_color_background");
    submit.value = button_label;
    footer.appendChild(submit);
    if (delete_cb === undefined) {
      submit.classList.add("full-width");
    }

    if (style === OverlayStyle.Classic) {
      body.onsubmit = function (e) {
        e.preventDefault();
        submit_cb();
      }
      body.appendChild(footer);
    }
    this.panel.appendChild(body);
    this.cover.appendChild(this.panel);
    document.body.appendChild(this.cover);
    if (open_cb) {
      open_cb();
    }
    Overlay.overlays.push(this);
    window.setTimeout(function () {
      self.cover.classList.add("open");
    }, 20);
  }

  close() {
    if (!this.dismissible) {
      return;
    }
    Overlay.overlays.pop();
    this.cover.classList.remove("open");
    const self = this;
    window.setTimeout(function () {
      if (self.cover.parentNode) {
        self.cover.parentNode.removeChild(self.cover);
      }
      if (self.cancel_cb) {
        self.cancel_cb();
      }
    }, 120);
  }

  static current(): Overlay | undefined {
    if (Overlay.overlays.length == 0) {
      return undefined;
    }
    return Overlay.overlays[Overlay.overlays.length - 1];
  }

  static disableDismissal() {
    const current = Overlay.current();
    if (current === undefined) {
      return;
    }
    current.panel.classList.add("no-dismiss");
    current.dismissible = false;
  }

  static enableDismissal() {
    const current = Overlay.current();
    if (current === undefined) {
      return;
    }
    current.panel.classList.remove("no-dismiss");
    current.dismissible = true;
  }

  static close() {
    const current = Overlay.current();
    if (current === undefined) {
      return;
    }
    current.close();
  }

  static deleteConfirmByTypingOverlay(title: string, message: string, confirm_message: string, confirm_string: string, cb: Function): Overlay {
    const d = div("overlay-panel-body");
    d.style.maxWidth = (window.innerWidth - 200) + "px";

    const settings = div("message");
    const message_el = document.createElement("p");
    message_el.innerHTML = message;
    const confirm_message_el = document.createElement("p");
    confirm_message_el.innerHTML = confirm_message;
    const name_input = document.createElement("input");
    name_input.value = "";
    settings.appendChild(message_el);
    settings.appendChild(confirm_message_el);
    settings.appendChild(name_input);
    d.appendChild(settings);

    const panel_footer = div("overlay-panel-footer");
    panel_footer.appendChild(div("spacer"));
    const button = document.createElement("a");
    button.classList.add("button", "noselect");
    button.innerHTML = "Delete";
    const disabled = "disabled";
    button.classList.add(disabled, "destructive");

    const loading = Loading.overlay();
    button.appendChild(loading);

    panel_footer.appendChild(button);
    d.appendChild(panel_footer);

    name_input.oninput = function () {
      if (name_input.value === confirm_string) {
        button.classList.remove(disabled);
      } else {
        button.classList.add(disabled);
      }
    };

    button.onclick = function (e) {
      e.preventDefault();
      if (name_input.value !== confirm_string) {
        return;
      }
      button.classList.add("working");
      cb();
    };

    const overlay = new Overlay(OverlayStyle.Viz, title, [d], "Delete", function () { });
    return overlay;
  }

  static deleteConfirmOverlay(title: string, message: string, cb: Function): Overlay {
    const d = div("overlay-panel-body");

    const settings = div("message");
    const message_el = document.createElement("p");
    message_el.innerHTML = message;
    settings.appendChild(message_el);
    d.appendChild(settings);

    const panel_footer = div("overlay-panel-footer");

    const cancel = document.createElement("a");
    cancel.classList.add("button", "noselect", "cancel", "half-button");
    cancel.innerHTML = "Cancel";
    panel_footer.appendChild(cancel);
    cancel.onclick = function () {
      Overlay.close();
    }

    panel_footer.appendChild(div("spacer"));

    const button = document.createElement("a");
    button.classList.add("button", "noselect", "destructive", "half-button");
    button.innerHTML = "Delete";

    const loading = Loading.overlay();
    button.appendChild(loading);

    panel_footer.appendChild(button);
    d.appendChild(panel_footer);

    button.onclick = function (e) {
      e.preventDefault();
      button.classList.add("working");
      cb();
    };

    const overlay = new Overlay(OverlayStyle.Viz, title, [d], "Delete", function () { });
    overlay.panel.classList.add("small");
    return overlay;
  }
}

document.addEventListener("keydown", function (e) {
  if (e.keyCode === 27) { //esc
    Overlay.close();
  }
})
